export default __webpack_public_path__ + "static/BAP_5022-Verbessert-NR_rgb_fein-f4e76cbc8bed8d144d2d79ae4ac77d76.jpg";